module.exports = __webpack_public_path__ + "img/bizlogo.4168a075.jpeg";